import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl8 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import { Befehl8FormData, createBefehl8FormValidationSchema } from './schema'
import {
  convertBefehl8FormDataToModel,
  convertModelToBefehl8FormData
} from './converters'
import { Auftrag8_50Form } from './Auftrag8_50Form'

export default function Befehl8Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-8-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl8>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl8FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl8FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl8FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl8FormData) => {
      const updatedBefehl = convertBefehl8FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl8FormData>
      befehlKennung="8"
      title={t('befehle.8.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <Auftrag8_50Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-8-50`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
